import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import { PageHeader, Section, StatBadge } from "@/components/Chrome";
import { api } from "@/lib/api";
import { toast } from "sonner";

export default function ScheduledTasks() {
  const qc = useQueryClient();
  const { data: tasks = [] } = useQuery({ queryKey: ["tasks"], queryFn: api.tasks.list });

  const toggle = useMutation({
    mutationFn: (id) => api.tasks.toggle(id),
    onSuccess: () => qc.invalidateQueries({ queryKey: ["tasks"] }),
  });
  const runNow = useMutation({
    mutationFn: (id) => api.tasks.runNow(id),
    onSuccess: (d) => { qc.invalidateQueries({ queryKey: ["activity"] }); toast.success("Ran now. See the briefing in Activity log."); },
  });

  return (
    <div data-testid="tasks-page">
      <PageHeader eyebrow="Automation" title="Scheduled tasks" subtitle="Cron-driven jobs Copilot runs autonomously. Change your briefing time on the Setup page." />
      <Section title="Jobs">
        {tasks.length === 0 ? (
          <div className="text-sm text-stone-500">No jobs.</div>
        ) : (
          <ul className="divide-y divide-stone-800/70" data-testid="tasks-list">
            {tasks.map((t) => (
              <li key={t.id} className="py-4 grid grid-cols-12 items-center gap-4" data-testid={`task-${t.id}`}>
                <div className="col-span-5">
                  <div className="text-sm text-stone-100">{t.name}</div>
                  <div className="text-[10px] font-mono uppercase tracking-widest text-stone-500 mt-1">{t.schedule} · {t.time_hhmm}</div>
                </div>
                <div className="col-span-3">
                  <StatBadge status={t.enabled ? "success" : "info"}>{t.enabled ? "Enabled" : "Paused"}</StatBadge>
                </div>
                <div className="col-span-2 text-xs text-stone-500 font-mono">
                  {t.last_run ? new Date(t.last_run).toLocaleString() : "never run"}
                </div>
                <div className="col-span-2 flex justify-end gap-2">
                  <button data-testid={`toggle-${t.id}`}
                    onClick={() => toggle.mutate(t.id)}
                    className="text-[10px] uppercase tracking-widest font-mono px-3 py-1.5 border border-stone-700 text-stone-400 hover:text-stone-100 hover:border-stone-500 transition-colors">
                    {t.enabled ? "Pause" : "Enable"}
                  </button>
                  <button data-testid={`run-${t.id}`}
                    onClick={() => runNow.mutate(t.id)}
                    className="text-[10px] uppercase tracking-widest font-mono px-3 py-1.5 bg-orange-600 hover:bg-orange-500 text-white transition-colors">
                    Run now
                  </button>
                </div>
              </li>
            ))}
          </ul>
        )}
      </Section>
    </div>
  );
}
